import { Component, Input, OnInit } from "@angular/core";
import { MatCardModule } from "@angular/material/card";
import { NgClass } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { TranslateModule } from "@ngx-translate/core";

type Alert = {
  title: string;
  type: "success" | "error" | "warning" | "info";
  subtitle?: string;
  duration?: number;
  autoClose?: boolean;
  closeIcon?: boolean;
};

@Component({
    selector: "app-alert",
    imports: [
        MatCardModule,
        NgClass,
        MatIconModule,
        MatButtonModule,
        TranslateModule,
    ],
    templateUrl: "./alert.component.html",
    styleUrl: "./alert.component.scss"
})
export class AlertComponent implements OnInit {
  @Input() config: Alert | null = null;

  ngOnInit() {
    if (this.config?.autoClose) {
      setTimeout(() => {
        this.onDismiss();
      }, this.config?.duration || 5000);
    }
  }

  onDismiss() {
    this.config = null;
  }
}
